export const invoicePaymentFormExpireDates = [
    {
      value: 1,
      label: "7 Gün",
    },
    {
      value: 2,
      label: "30 Gün",
    },
    {
      value: 3,
      label: "60 Gün",
    },
    {
      value: 4,
      label: "90 Gün",
    },
    {
      value: 5,
      label: "120 Gün",
    }
  ];

  export const getInvoicePaymentFormExpireOptionById = (id: number) => {
    var index = invoicePaymentFormExpireDates.findIndex(w => w.value == id);
    return invoicePaymentFormExpireDates[index];
  }